import React from 'react';
import { BillConceptos } from '../../../models/Factura';
import { formatCurrencyStyled } from '../../visuals/currency.formatted';

interface PreviewConceptosProps {
    conceptos: BillConceptos[];
    showNoIdentificacion?: boolean;
    /** Nota de crédito conceptos use an extra class on the unit price */
    valorClassName?: string;
}

const taxLabel = (tax: BillConceptos['impuestos'][0]) => (
    tax.tasa ? `${Math.round((tax.tasa * 100) * 10000) / 10000}%` : (tax.cuota ? `$ ${tax.cuota} / unidad` : '0%')
)

function PreviewConceptos({ conceptos, showNoIdentificacion, valorClassName = '_price' }: PreviewConceptosProps) {
    return (
        <div className="conceptosWrap">
            <span className="label">Conceptos:</span>
            {conceptos.map((concepto, i) => (
                <div className="concepto" key={i}>
                    <p className='_index'>#{i + 1}</p>
                    <p className='_name'>
                        {concepto.descripcion}
                        {
                            showNoIdentificacion && concepto.noIdentificacion ?
                                <span className='small lightGray'><br />{`${concepto.noIdentificacion}`}</span>
                                : null
                        }
                    </p>
                    <div className="_claves">
                        <p><span>Clave</span> ProdServ: {concepto.claveProdServ}</p>
                        <p><span>Clave</span> Unidad: {concepto.claveUnidad}</p>
                    </div>
                    <p className="_cantidad">
                        (x{concepto.cantidad})
                    </p>
                    <p className={valorClassName}>
                        {formatCurrencyStyled(concepto.valorUnitario)}
                    </p>
                    <div className="_impuestos">
                        {concepto.impuestos.map((tax, i) => (
                            <p key={i}>
                                {tax.type.toUpperCase()}{tax.retencion ? ' retenido: ' : ':'} {taxLabel(tax)}
                            </p>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default PreviewConceptos;
